<template>
  <div class="flex flex-col justify-center items-center break-words bg-shade-white">
    <BodyText
      size="large"
      class="font-bold"
    >
      Logging out
    </BodyText>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, onMounted } from 'vue'
import { useAuthStore } from '@shared/stores/auth'

const BodyText = defineAsyncComponent(() => import('@shared/design-system/components/Typography/BodyText.vue'))

const authStore = useAuthStore()

onMounted(async () => await authStore.logoutAndRedirect())

</script>